import { basePathInit } from '@/envConst';

export default (Vue) => {

  const http = Vue.prototype.$http;

  const basePath = basePathInit();

  var service = {
    getDemoList(params) {
      return http({
        baseDomain: basePath.bossapi.system,
        url: 'ajax/brands/all.do',
        method: 'get',
        params
      });
    }
  };
  return service;
};